import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
	Row,
	Col,
	Grid,
	Panel,
	PanelBody,
	PanelContainer,
	Button,
	ButtonToolbar
} from '@sketchpixy/rubix';

export default class NotFoundPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
   	}

	render() {
		return (
			<PanelContainer>
				<Panel>
					<PanelBody style={{padding: 20, paddingBottom: 25}}>
						<h1>Erreur 404 : Page inexistante.</h1>
					</PanelBody>
				</Panel>
			</PanelContainer>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/layout/404.js
 **/